import { TFunction } from 'i18next';
import { z } from 'zod';

import { PaymentTerms } from '../types';

export const getClientInfoSchema = (t: TFunction) => {
  return z.object({
    name: z.string().min(1, t('common:error.required')),
    paymentTerms: z.nativeEnum(PaymentTerms),
    email: z
      .string()
      .email(t('common:error.emailInvalid'))
      .or(z.literal(''))
      .optional()
      .transform(val => (val === '' ? undefined : val)),
    avatar: z.instanceof(File).optional().nullable(),
    managerId: z.string().optional(),
    billingAddress: z.string().optional(),
    shippingAddress: z.string().optional(),
  });
};

export type ClientInfoFormData = z.infer<ReturnType<typeof getClientInfoSchema>>;
